import axios from "axios";
const API_URL = process.env.REACT_APP_CHANGEINITIATION_API_URL + "user" ; //process.env.REACT_APP_EMPLOYEE_API_URL;
//const axios = require("axios");

export const authenticate = async (idToken,email) => {
    // debugger;
    // let  headers = { headers : {Authorization : `Bearer ${accessToken}`}}
    let  headers = { headers : {Authorization : `Bearer ${idToken}`}}
    console.log("Inside authenticate");
    console.log("useraccessToken",idToken); 
    console.log("headers =====> ",headers);

    let userUrl = `${API_URL}/authenticate`;
    let requestBody = {
        emailId:email
        }
    
        //   axios.post(Helper.getUserAPI(), data, {
        //       headers: headers
        //     })  .then((response) => {
        //       dispatch({
        //         type: FOUND_USER,
        //         data: response.data[0]
        //       })
        //     })
        //     .catch((error) => {
        //       dispatch({
        //         type: ERROR_FINDING_USER
        //       })
        //     })
            
    const response = await axios
      .post(userUrl,requestBody,headers)
      .then(function (resp) {
        if (resp.status === 200) {
          console.log("resp =====> ",resp); 
          console.log("resp.header =====> ",resp.header); 
          localStorage.setItem(
            "UserData",
            resp?.data ? JSON.stringify(resp?.data) : ""
          );
          localStorage.setItem("Token", resp?.data?.Token);
        }
        // debugger;
        return resp;
      })
      .catch(function (error) {
        console.log("error => ", error);
        return { message: error.response.data.Message, status: false };
      });
    return response;
  };


//  export async function authenticate(accessToken) { 
//     //// debugger;   
//     let options = { headers : {Authorization : `Bearer ${accessToken}`}}
//     let userUrl = `${API_URL}/authenticate`;
//     console.log(userUrl);
//     return fetch(userUrl,options)
//         .then(response => response.json());
// }